import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, Crown, Lightning, Sparkle } from "@phosphor-icons/react";
import { api } from "@/lib/api";

const ICONS = { standart: Lightning, plus: Sparkle, pro: Crown };
const ACCENT = { standart: "#7dd3fc", plus: "#2dd4bf", pro: "#fdba74" };

export const usePlans = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/billing/plans").then((r) => setData(r.data)).catch(() => setData({ plans: [] })); }, []);
  return data;
};

export const PlanCard = ({ plan, dark, current, action, delay = 0 }) => {
  const Icon = ICONS[plan.id];
  const accent = ACCENT[plan.id];
  const featured = plan.id === "plus";
  return (
    <div
      className={`fade-up relative flex flex-col border p-6 transition-transform hover:-translate-y-1 ${dark ? "border-white/10 bg-white/5 text-zinc-300" : "border-slate-200 bg-white text-slate-700"} ${featured ? "ring-2" : ""}`}
      style={{ animationDelay: `${delay}ms`, ...(featured ? { "--tw-ring-color": accent } : {}) }}
      data-testid={`plan-card-${plan.id}`}
    >
      {featured && <span className="absolute -top-3 left-6 bg-[#2dd4bf] px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-zinc-950">En popüler</span>}
      {current && <span className="absolute -top-3 right-6 bg-zinc-950 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-white" data-testid="plan-current-badge">Mevcut plan</span>}
      <div className="flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-full" style={{ background: accent }}><Icon weight="fill" className="text-zinc-950" size={16} /></span>
        <h3 className={`font-display text-xl font-bold ${dark ? "text-white" : "text-slate-900"}`}>{plan.name}</h3>
      </div>
      <p className="mt-1 text-xs uppercase tracking-[0.2em]" style={{ color: accent }}>{plan.tagline}</p>
      <div className="mt-4 flex items-baseline gap-1">
        <span className={`font-num text-4xl font-bold ${dark ? "text-white" : "text-slate-900"}`} data-testid={`plan-price-${plan.id}`}>{plan.price.toLocaleString("tr-TR")} TL</span>
        <span className="text-sm opacity-70">/ ay</span>
      </div>
      <ul className="mt-5 flex-1 space-y-2 text-sm">
        {plan.features.map((f) => (
          <li key={f} className="flex items-start gap-2"><Check weight="bold" size={16} className="mt-0.5 shrink-0" style={{ color: accent }} />{f}</li>
        ))}
      </ul>
      <div className="mt-6">{action}</div>
    </div>
  );
};

export const PricingSection = ({ dark = true }) => {
  const data = usePlans();
  if (!data?.plans?.length) return null;
  return (
    <section className="space-y-6" data-testid="pricing-section">
      <div>
        <p className={`text-[11px] font-semibold uppercase tracking-[0.3em] ${dark ? "text-[#7dd3fc]" : "text-teal-700"}`}>Planlar</p>
        <h2 className={`mt-2 font-display text-3xl font-bold ${dark ? "text-white" : "text-slate-900"}`}>Her ödeme 30 gün kullanım sağlar.</h2>
        <p className={`mt-2 text-sm ${dark ? "text-zinc-400" : "text-slate-600"}`}>Yeni kayıt olan herkes 14 gün boyunca tüm Pro özelliklerini ücretsiz kullanır. Kredi kartı gerekmez.</p>
      </div>
      <div className="grid gap-4 md:grid-cols-3">
        {data.plans.map((p, i) => (
          <PlanCard key={p.id} plan={p} dark={dark} delay={i * 120} action={
            <Link to="/kayit" className="block w-full bg-zinc-950 py-2.5 text-center text-sm font-bold text-white transition-colors hover:bg-zinc-800" style={dark ? { background: ACCENT[p.id], color: "#09090b" } : {}} data-testid={`plan-cta-${p.id}`}>
              14 gün ücretsiz dene
            </Link>
          } />
        ))}
      </div>
    </section>
  );
};
